import Translator from '../../classes/Translator/Translator';

const ProjectSpecsTableLogic = (getKeys) => {
  const { translator } = Translator();

  return {
    translator,
  };
};
export default ProjectSpecsTableLogic;
